var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmojiMonocle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4288 67.8285C51.8478 67.8285 50.1335 67.5047 48.3049 66.7237C47.924 66.5523 47.7335 66.1142 47.9049 65.7332C48.0764 65.3523 48.5145 65.1618 48.8954 65.3332C54.6859 67.7713 59.2002 65.1999 61.5049 61.9808C61.7526 61.638 62.2287 61.5618 62.5716 61.8094C62.9145 62.057 62.9906 62.5332 62.743 62.8761C60.8383 65.5237 57.5811 67.8285 53.4288 67.8285Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 70.4762C56.8316 70.4762 70.4763 56.8315 70.4763 40C70.4763 23.1685 56.8316 9.5238 40.0001 9.5238C23.1686 9.5238 9.52393 23.1685 9.52393 40C9.52393 56.8315 23.1686 70.4762 40.0001 70.4762Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.0001 70.4762C56.8316 70.4762 70.4763 56.8315 70.4763 40C70.4763 23.1685 56.8316 9.5238 40.0001 9.5238C23.1686 9.5238 9.52393 23.1685 9.52393 40C9.52393 56.8315 23.1686 70.4762 40.0001 70.4762Z",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.3717 50.057C51.8288 50.2094 54.1145 49.6189 56.0574 48.4761C56.5717 48.1713 57.2383 48.2285 57.6764 48.6475C57.8479 48.8189 58.0193 48.9332 58.2288 49.0285C58.6479 50.6285 59.5431 52.038 60.4383 53.4094C61.9241 55.7142 63.2383 57.7713 62.4574 60.5713C63.0669 59.9046 63.6383 59.2189 64.1907 58.5142C64.0383 56.2284 62.8383 54.3427 61.7145 52.5903C60.9717 51.4284 60.2479 50.3046 59.8479 49.1047C60.1145 49.0094 60.3622 48.857 60.5717 48.6285C61.2764 47.9237 61.3526 46.838 60.8193 46.038C60.7812 45.9999 60.7622 45.9427 60.7241 45.9046C60.7241 45.9046 60.7241 45.9046 60.7241 45.8856C60.686 45.8285 60.6288 45.7903 60.5907 45.7332L59.8288 44.9903C61.2955 42.8761 62.1145 40.2665 61.9241 37.4665C61.5431 31.4475 56.5526 26.6285 50.5145 26.438C43.6955 26.2285 38.1145 31.7904 38.3241 38.6285C38.5336 44.6856 43.3336 49.6761 49.3717 50.057ZM50.1336 28.5904C55.486 28.5904 59.8098 32.9332 59.8098 38.2666C59.8098 43.5999 55.4669 47.9427 50.1336 47.9427C44.7812 47.9427 40.4574 43.5999 40.4574 38.2666C40.4574 32.9332 44.8003 28.5904 50.1336 28.5904Z",
    fill: "url(#paint3_radial)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0569 41.295C31.6769 41.295 32.9902 39.308 32.9902 36.8569C32.9902 34.4058 31.6769 32.4188 30.0569 32.4188C28.4368 32.4188 27.1235 34.4058 27.1235 36.8569C27.1235 39.308 28.4368 41.295 30.0569 41.295Z",
    fill: "url(#paint4_radial)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0569 33.9236C31.314 33.9236 32.4188 35.0284 32.9902 36.6474C32.9521 34.2474 31.6569 32.3236 30.0569 32.3236C28.4569 32.3236 27.1616 34.2474 27.1235 36.6474C27.695 35.0284 28.7807 33.9236 30.0569 33.9236Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9431 41.295C51.5631 41.295 52.8764 39.308 52.8764 36.8569C52.8764 34.4058 51.5631 32.4188 49.9431 32.4188C48.3231 32.4188 47.0098 34.4058 47.0098 36.8569C47.0098 39.308 48.3231 41.295 49.9431 41.295Z",
    fill: "url(#paint6_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9431 34.0383C48.686 34.0383 47.5812 35.143 47.0098 36.7621C47.0479 34.3621 48.3431 32.4383 49.9431 32.4383C51.5431 32.4383 52.8384 34.3621 52.8764 36.7621C52.305 35.143 51.2003 34.0383 49.9431 34.0383Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6094 27.9811C33.5046 28.0383 32.4951 28.0192 30.057 27.2954C26.457 26.2478 25.5808 27.0478 23.2189 29.2002C23.0475 29.3526 22.857 29.524 22.6665 29.6954C22.2856 30.0383 22.2284 30.6668 22.5713 31.1621C22.7808 31.4668 23.6189 31.9621 24.3618 31.3335C26.6665 29.4097 28.3618 29.6192 30.3999 30.1144C32.0189 30.4954 33.6951 30.9144 35.4856 30.0383C36.2094 29.6954 36.3999 29.1811 36.2284 28.6287C36.0189 27.943 35.3903 27.924 34.6094 27.9811Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5239 24.362C46.6286 24.2667 47.562 23.981 49.9429 23.0096C52.8953 21.8096 54.9143 22.4191 56.9715 23.8858C57.162 24.0191 57.3715 24.1525 57.6001 24.3048C58.0382 24.5905 58.1715 25.2191 57.9048 25.7334C57.7524 26.0572 56.9715 26.6667 56.1524 26.1715C53.581 24.6096 51.9429 25.0667 50.0001 25.8477C48.4572 26.4763 46.8572 27.1239 44.9524 26.5144C44.1905 26.2667 43.9239 25.8096 44 25.2382C44.1143 24.5525 44.7429 24.4382 45.5239 24.362Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8383 59.1237C48.705 59.1237 48.5907 59.1047 48.4574 59.0666C48.4193 59.0666 45.486 58.2285 41.9241 57.7332C37.3717 57.1047 33.886 57.257 31.8288 58.2094C31.1622 58.5142 30.3622 58.2285 30.0574 57.5618C29.7526 56.8951 30.0383 56.0951 30.705 55.7904C36.686 53.0094 48.6669 56.3428 49.1622 56.4951C49.8669 56.6856 50.286 57.4285 50.0764 58.1332C49.9431 58.7237 49.4098 59.1047 48.8383 59.1237Z",
    fill: "#643800"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1523 57.7332C50.1332 57.1618 49.7523 56.6666 49.1808 56.4951C48.6665 56.3428 36.7046 53.0285 30.7237 55.7904C30.0951 56.0761 29.8094 56.7809 30.0189 57.4094C32.7237 55.3904 37.257 54.3618 50.1523 57.7332Z",
    fill: "url(#paint10_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1147 63.1621C61.9814 63.1621 61.829 63.124 61.7147 63.0478C61.3528 62.8192 61.2576 62.3431 61.4861 62.0002C64.1719 57.7907 62.5338 55.2383 60.6481 52.2859C59.4481 50.4192 58.21 48.4764 58.21 46.0573C58.21 45.6383 58.5528 45.2954 58.9719 45.2954C59.3909 45.2954 59.7338 45.6383 59.7338 46.0573C59.7338 48.0193 60.8004 49.6954 61.9433 51.4669C63.8481 54.4192 66.0004 57.7907 62.7814 62.8193C62.61 63.0478 62.3623 63.1621 62.1147 63.1621Z",
    fill: "url(#paint11_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9427 26.0193C43.8093 26.0193 38.8379 30.9908 38.8379 37.1241C38.8379 43.2575 43.8093 48.2289 49.9427 48.2289C56.076 48.2289 61.0474 43.2575 61.0474 37.1241C61.0665 30.9908 56.076 26.0193 49.9427 26.0193ZM49.9427 46.8003C44.5903 46.8003 40.2665 42.4575 40.2665 37.1241C40.2665 31.7717 44.6093 27.4479 49.9427 27.4479C55.276 27.4479 59.6189 31.7908 59.6189 37.1241C59.6189 42.4765 55.295 46.8003 49.9427 46.8003Z",
    fill: "url(#paint12_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9428 25.3144C43.4285 25.3144 38.1333 30.6096 38.1333 37.1239C38.1333 43.6382 43.4285 48.9334 49.9428 48.9334C56.4571 48.9334 61.7524 43.6382 61.7524 37.1239C61.7524 30.6096 56.4762 25.3144 49.9428 25.3144ZM49.9428 47.6572C44.1143 47.6572 39.4095 42.9334 39.4095 37.1239C39.4095 31.3144 44.1333 26.5906 49.9428 26.5906C55.7524 26.5906 60.4762 31.3144 60.4762 37.1239C60.4762 42.9334 55.7714 47.6572 49.9428 47.6572Z",
    fill: "url(#paint13_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9429 46.1145C54.9082 46.1145 58.9333 42.0893 58.9333 37.124C58.9333 32.1587 54.9082 28.1335 49.9429 28.1335C44.9776 28.1335 40.9524 32.1587 40.9524 37.124C40.9524 42.0893 44.9776 46.1145 49.9429 46.1145Z",
    fill: "url(#paint14_radial)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.7428 27.8666C57.8667 29.4095 60.7619 34.7999 59.219 39.9237C57.6762 45.0475 52.2857 47.9428 47.1619 46.3999C42.0381 44.8571 39.1428 39.4666 40.6857 34.3428C42.2286 29.219 47.619 26.3237 52.7428 27.8666Z",
    fill: "url(#paint15_radial)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6475 44.9143C60.6094 44.8762 60.5904 44.8191 60.5523 44.781C60.5523 44.781 60.5523 44.781 60.5523 44.7619C60.5142 44.7048 60.4571 44.6667 60.419 44.6095L59.2951 43.5238C58.9142 44.0953 58.4571 44.6286 57.9618 45.1238C57.4666 45.6191 56.9142 46.0572 56.3618 46.4572L57.5237 47.5048C58.3237 48.3048 59.619 48.3048 60.419 47.5048C61.1047 46.8 61.1809 45.7143 60.6475 44.9143Z",
    fill: "url(#paint16_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9526 46.9145C59.426 46.9145 59.8097 46.5307 59.8097 46.0573C59.8097 45.584 59.426 45.2002 58.9526 45.2002C58.4792 45.2002 58.0955 45.584 58.0955 46.0573C58.0955 46.5307 58.4792 46.9145 58.9526 46.9145Z",
    fill: "url(#paint17_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 56.619,
    y1: 63.7863,
    x2: 60.238,
    y2: 61.3101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#643800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#975500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0018 27.6485) scale(36.7656)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0018 27.6485) scale(28.9251)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1772 46.2161) scale(32.1877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#894D00",
    stopOpacity: 0.2069
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#975500",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1418 36.9755) rotate(73.8539) scale(4.30607 2.78595)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 30.0476,
    y1: 32.4011,
    x2: 30.0476,
    y2: 36.5372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0434 36.9762) rotate(73.8539) scale(4.30607 2.78596)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 49.9483,
    y1: 32.5104,
    x2: 49.9483,
    y2: 36.6464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 29.1266,
    y1: 32.2112,
    x2: 29.4096,
    y2: 28.4381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 51.5727,
    y1: 27.7544,
    x2: 50.7592,
    y2: 24.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 40.1906,
    y1: 60.73,
    x2: 39.6204,
    y2: 47.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 58.3208,
    y1: 48.2838,
    x2: 62.2964,
    y2: 58.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#643800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#975500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 47.2984,
    y1: 27.9783,
    x2: 57.2032,
    y2: 62.1688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA5A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 53.4037,
    y1: 56.1923,
    x2: 45.4989,
    y2: 12.5732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA5A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.7391 32.4984) scale(12.1746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5026 31.4768) rotate(-163.238) scale(20.2916 20.291)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 57.6356,
    y1: 46.4503,
    x2: 63.7308,
    y2: 44.1169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA5A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 57.87,
    y1: 51.232,
    x2: 59.1398,
    y2: 45.1367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA5A8"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmojiMonocle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emoji_monocle.7fc0abde39bcb35a45b18d8a7a2f1fb6.svg";